import { useFocusVisible } from '@react-aria/interactions';
import { useLink } from '@react-aria/link';
import useMergedRef from '@react-hook/merged-ref';
import React, { useRef } from 'react';
import { mergeProps } from '@react-aria/utils';
import { useExternalLink } from '../../hooks/index.js';
import { LinkElement } from './link.styles.js';
export const Link = React.forwardRef(({ elementType = 'a', href, rel, target, setting = 'standalone', variant = 'default', children, ...rest }, forwardedRef) => {
    const linkRef = useRef(null);
    const ref = useMergedRef(forwardedRef, linkRef);
    const externalLinkProps = useExternalLink({ href, target, rel });
    const isDisabled = Boolean(rest.loading || rest.isDisabled);
    const { linkProps } = useLink({
        ...rest,
        elementType: typeof elementType === 'string' ? elementType : 'div',
        isDisabled,
    }, linkRef);
    const { isFocusVisible } = useFocusVisible();
    const role = elementType === 'button' ? 'button' : linkProps.role;
    return (React.createElement(LinkElement, { ref: ref, elementType: elementType, ...rest, ...linkProps, ...mergeProps(linkProps, {
            onClick: (e) => {
                rest.shouldPreventNavigation && e.preventDefault();
            },
        }), ...externalLinkProps, role: role, variant: variant, setting: setting, href: href, isDisabled: isDisabled, isFocusVisible: isFocusVisible }, children));
});
//# sourceMappingURL=link.component.js.map